import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "js-cookie";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from 'react-spinners';
import Skeleton from 'react-loading-skeleton'
import { Table } from "antd";
import { adminMainUrl } from '../../Config.jsx';
import { getCustomerDocumentList, getKycDocList, getKycDocView } from "../../Redux/action/Admin/CustomerAction.js";
import Pagination from "../../Admin/Masters/Pagination.jsx";
import DisapprovalReason from "./DisapprovalReason.jsx";


const KycDoc = () => {

  const { b64id } = useParams();
  const navigate = useNavigate()
  const urlString = window.location.href;
  const url = new URL(urlString);
  const path = url.pathname.slice(1);
  const searchParams = url.search;
  const q = path + searchParams;
  const token = Cookies.get("token");
  let customer_id = atob(b64id)
  useEffect(() => {
    if (!token) {
      toast.error("Please login to continue.");
      navigate(`/login?burl=${encodeURIComponent(q)}`);
    } else {
      if (b64id) {
        customer_id = atob(b64id);

      } else {
        toast.error("Please enter correct url.")
        navigate(-1);
      }
    }

  }, []);
  const [currentData, setCurrentData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [dataOffset, setDataOffset] = useState(0);

  const dataPerPage = 10;
  const [reload, setReload] = useState(false);
  const [spinnerLoader, setSpinnerLoader] = useState(false)
  const [RequiredServiceName, setRequiredServiceName] = useState(null);
  const [RequiredServiceId, setRequiredServiceId] = useState(null);

  // const { name } = useParams();
  const dispatch = useDispatch();
  const {
    loadingCustomerDocumentListApi,
    CustomerDocumentListError,
    CustomerDocumentList,



  } = useSelector((state) => state?.CustomerReducer);
  useEffect(() => {
    dispatch(getCustomerDocumentList(customer_id));
  }, [customer_id, reload]);
  const handleSuccess = () => {
    // Toggle reload to trigger useEffect
    setReload((prev) => !prev);
  };
  const isValidJson = (str) => {
    try {

      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
  const [id, setid] = useState(null)
  const [addShow, setAddShow] = useState(false);
  const handleAddClose = () => setAddShow(false);
  const handleAddShow = (id) => {
    setid(id)
    setAddShow(true);
  };
  // Initialize Formik
  const statusChange = async (id) => {
    setSpinnerLoader(true)
    try {
      const response = await fetch(
        `${adminMainUrl}/api/kyc-doc/status-change`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        setSpinnerLoader(false)
        handleSuccess(); // Call the success handler
        toast.success(data?.msg);
      } else {
        setSpinnerLoader(false)
        toast.error(data?.msg);
      }
    } catch (error) {
      setSpinnerLoader(false)
      console.error("Network error:", error);
    }
  };
  const handleApproval = async (id) => {

    try {
      const response = await fetch(
        `${adminMainUrl}/api/customer/document-approval`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
          },
          body: JSON.stringify({ id: id.toString() }),
        }
      );

      const data = await response.json();

      if (response.ok) {

        handleSuccess();
        toast.success(data?.msg);
      } else {

        toast.error(data?.msg);
      }
    } catch (error) {

      console.error("Network error:", error);
    }
  };

  const [grid, setGrid] = useState(true)
  const arr = new Array(5).fill(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const onSelectChange = newSelectedRowKeys => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange
  }


  const currentItems = CustomerDocumentList
  const columns = [
    { title: "S. No.", dataIndex: "SNo", key: "SNo" },
    { title: "Document Name", dataIndex: "documentName", key: "documentName" },
    { title: "File", dataIndex: "image", key: "image" },

    // { title: "Approval", dataIndex: "Approval", key: "Approval" },


  ];
  const renderApproval = (value) => {
    return value.approval === 'REQUESTED' ? (
      <>
        <span onClick={() => handleApproval(value?.id)}>
          <i className="fa fa-check accept me-2 cursor-pointer" aria-hidden="true"></i>

        </span>
        <span onClick={() => handleAddShow(value?.id)}>

          <i className="fa fa-close reject cursor-pointer" aria-hidden="true"></i>
        </span>

      </>
    ) : value?.approval;
  };
  const dataSource = currentData?.map((value, i) => (
    {
      key: i,
      SNo: i + 1,
      documentName: value?.documentName,
      image: (<><a className="icon-background" href={`${adminMainUrl}/${value?.image}`} target="blank" title="View File">
        <i className=" fa fa-eye"></i>
      </a><a className="icon-background" href={`${adminMainUrl}/${value?.image}`} download title="Download File">
          <i className=" fa fa-download"></i>
        </a></>),


      // "Approval": renderApproval(value),

    }));

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="contact-head">
            <div className="row align-items-center mb-3 ">
              <div className="col-sm-6">
                <ul className="contact-breadcrumb">
                  <li className="mb-0">
                    <Link to={-1}>
                      <i className="ti ti-arrow-narrow-left" />
                      Back
                    </Link>
                  </li>

                </ul>
              </div>


            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-8">
                    <h4 className="page-title">
                      Customer Documents<span className="count-title">{CustomerDocumentList?.length}</span>
                    </h4>
                  </div>
                  <div className="col-4 text-end">
                    <div className="head-icons">
                      <a
                        href="javascript:void(0);"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-original-title="Collapse"
                        id="collapse-header"
                      >
                        <i className="ti ti-chevrons-up" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
            </div>
          </div>
          <div className="card">

            <div className="card-body">

              {/* Contact List */}
              {
                loadingCustomerDocumentListApi
                  ?
                  arr.map((value, index) => {
                    return (

                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    )
                  }) :
                  spinnerLoader ?
                    <>
                      <div className='d-flex justify-content-center align-items-center' style={{ height: "400px", width: "100%" }}>
                        <BeatLoader />
                      </div>
                    </> :
                    <>
                      <div className="table-responsive custom-table">
                        <Table className="table datanew dataTable no-footer" pagination={false}
                          dataSource={dataSource} columns={columns} />
                      </div>

                      <Pagination data={currentItems} dataPerPage={dataPerPage} setDataOffset={setDataOffset} dataOffset={dataOffset} setPageCount={setPageCount} pageCount={pageCount} setCurrentData={setCurrentData} currentData={currentData} />
                    </>
              }
              {/* <div className="pagination-controls my-5 d-flex justify-content-center align-items-center">
                                <button
                                    className=''
                                    onClick={() => handlePageChange(count - 1)}
                                    disabled={count === 1}
                                >
                                    <img src="/img/right.png" className='mx-2' alt="right" />
                                </button>

                                {pageNumbers.map((number, index) =>
                                    number === '...' ? (
                                        <span key={index} className="mx-2">...</span>
                                    ) : (
                                        <span
                                            key={number}
                                            className={`search-btn-1 ${number === count ? 'active' : ''}`}
                                            onClick={() => handlePageChange(number)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {number}
                                        </span>
                                    )
                                )}

                                <button
                                    onClick={() => handlePageChange(count + 1)}
                                    disabled={count === totalPages}
                                >
                                    <img src="/img/left.png" className='mx-2' alt="right" />
                                </button>
                            </div> */}
            </div>
          </div>
        </div>
      </div>

      <DisapprovalReason show={addShow} handleClose={handleAddClose} onSuccess={handleSuccess} id={id} />
    </>

  )
}

export default KycDoc